if (!customElements.get('sx-extra-price')) {
  customElements.define('sx-extra-price', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      const update = () => this.update();
      document.addEventListener('sissilux:discounts-updated', update, { signal: this.abort.signal });
      this.update();
    }
    update() {
      const base = Number(this.dataset.price), id = Number(this.dataset.productId);
      const shared = window.SissiluxDiscounts;
      let cart = shared?.cart;
      if (!cart) { try { cart = JSON.parse(document.querySelector('[data-sissilux-cart]')?.textContent || 'null'); } catch {} }
      const compatible = !cart?.currency || cart.currency === this.dataset.currency;
      const items = compatible ? (cart?.items || []) : [];
      const tier = compatible && this.dataset.eligible === 'true' ? shared?.policy?.best(items.concat({ product_id:id, quantity:1 }),id) : null;
      const percent = tier?.percent || 0;
      const amount = percent ? shared.policy.price(base,percent) : base;
      const format = cents => new Intl.NumberFormat(this.dataset.locale || 'en',{style:'currency',currency:this.dataset.currency || 'USD'}).format(cents/100);
      this.querySelectorAll('[data-extra-amount]').forEach(node => {
        if (!node.dataset.originalText) node.dataset.originalText = node.textContent;
        node.textContent = percent ? (this.dataset.prefix || '') + format(amount) : node.dataset.originalText;
        node.setAttribute('aria-label',(percent ? 'Offer price ' : 'Current price ') + format(amount));
      });
      const current = this.querySelector('[data-extra-current]'), label = this.querySelector('[data-extra-label]');
      if (current) { current.hidden = !percent; current.textContent = percent ? 'Before extra savings: ' + format(base) : ''; }
      if (label) { label.hidden = !percent; label.textContent = percent ? 'Extra '+percent+'% off applied' : ''; label.title = percent ? 'Extra discount on the current price for eligible items' : ''; }
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
